import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import LogRocket from 'logrocket';
import configureStore from './configureStore';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, StaticRouter } from 'react-router-dom';

// import ReactDOMServer from 'react-dom/server';

const store = configureStore();
if (process.env.NODE_ENV === 'stage') {
  LogRocket.init('cfkpps/orca-test');
}

if (process.env.NODE_ENV === 'development') {
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>,
    document.getElementById('root')
  );
} else {
  ReactDOM.render(
    <StaticRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </StaticRouter>,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
